import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const Termos = () => {
    const { t } = useTranslation('terms');

    const [cookiesAceitos, setCookiesAceitos] = useState(
        localStorage.getItem('cookiesAceitos') === 'true'
    );

    useEffect(() => {
        if (cookiesAceitos) {
            const script = document.createElement('script');
            script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3329971741558817";
            script.async = true;
            script.crossOrigin = "anonymous";
            document.head.appendChild(script);

            script.onload = () => {
                console.log('✅ AdSense carregado após consentimento!');
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            };
        }
    }, [cookiesAceitos]);

    const aceitarCookies = () => {
        localStorage.setItem('cookiesAceitos', 'true');
        setCookiesAceitos(true);
    };

    return (
        <>
            <h2 className="terms-title container">{t('title')}</h2>
            <section className="terms-section container">
                <div className="terms-container">
                    <p>{t('intro')}</p>

                    <h3>{t('sections.use.title')}</h3>
                    <p>{t('sections.use.text')}</p>

                    <h3>{t('sections.privacy.title')}</h3>
                    <p>{t('sections.privacy.text')}</p>

                    <h3>{t('sections.copyright.title')}</h3>
                    <p>{t('sections.copyright.text')}</p>

                    <h3>{t('sections.changes.title')}</h3>
                    <p>{t('sections.changes.text')}</p>

                    {!cookiesAceitos && (
                        <div style={{ marginTop: '20px' }}>
                            <button onClick={aceitarCookies} className="botao-candidatar">
                                {t('accept_button') || 'Aceitar cookies'}
                            </button>
                        </div>
                    )}

                    {cookiesAceitos && (
                        <p style={{ marginTop: '10px', color: 'green' }}>
                            ✅ {t('accepted') || 'Cookies aceitos. Anúncios ativados.'}
                        </p>
                    )}
                </div>
            </section>
        </>
    );
};

export default Termos;
